const ELEPHANT_DEMO_ORG_IDS = [
  "59808069-d31e-49d0-bcd7-58d0523c73e5",
  "1aeb0f10-d78f-4b6d-a626-c2168c804a9c",
  "333d6d95-05a6-4356-8ee7-88da98a5f289",
];

export const isDemoOrg = (orgId: string) => {
  return ELEPHANT_DEMO_ORG_IDS.includes(orgId);
};
